








































import { Component } from "vue-property-decorator";
import { Gradient } from "@/components/wobble/model";
import Chapter from "./Chapter.vue";
import FloatingWobble from "@/components/wobble/FloatingWobble.vue";

@Component({
  components: {
    FloatingWobble,
  },
})
export default class GoToDesktop extends Chapter {
  public wobbleGradient = new Gradient(
    '#DF18FF',
    '#0D01FF',
    0.3242,
    0.5827,
    514.86,
    582.11,
    -125.19,
    -222.67,
  );
}
